<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import { fly } from 'svelte/transition';
import uiStore from '../utils/UIStore';
import Alert from './Alert.svelte';

let uiTexts;
uiStore.textStore.subscribe((store) => {
  uiTexts = store.texts;
});
</script>

<div in:fly={{ y: -20, duration: 500, delay: 200 }} class="top-info-bar">
    <Alert tone="cloud">
        <span class="red">{uiTexts.warning.attention}</span>
        <span style="color:#000"
            ><slot/>
        </span>

    </Alert>
</div>
